import React, { useState } from 'react'
import { RadialBarChart, RadialBar, Cell } from 'recharts'
import Barcode from 'react-jsbarcode'
import Tooltip from '@mui/material/Tooltip'
import Button from '@mui/material/Button'

function getColor(value, min_value, max_value, rssi = false) {
  if (value >= max_value)
    return rssi ? '#5AFA82' : '#FA1F47'
  else if (value >= min_value)
    return rssi ? '#F0CE51' : '#5AFA82'
  else
    return rssi ? '#FA1F47' : '#F0CE51'
}

const sideTextStyle = { fontSize: "0.5rem" }

const smallColumn = { width: 5 }

const tableSideStyle = {
  width: 5,
  border: 0,
  padding: 20,
  textTransform: "uppercase",
  transform: "rotate(-90deg)"
}

const gridStyle = {
  fontWeight: "bold",
  display: "block",
  height: "31.8em",
  overflow: "auto"
}

const ChannelGauge = React.memo(({value, min, max, size = 75, rssi = false}) => {
  const data = [{
    value: value,
    fill: getColor(value, min, max, rssi),
    label: value,
    max: max
  }]

  return (
    <RadialBarChart
      width={size}
      height={size}
      innerRadius="35%"
      outerRadius="100%"
      startAngle={180}
      endAngle={0}
      barCategoryGap={0}
      data={data}
      cy={size - 20}
      margin={{ top: -30, right: -10, bottom: 0, left: -10 }}
    >
      <RadialBar
        label={false}
        background={false}
        fill='#0000'
        dataKey='value'
        data={[{value: max}]}
        isAnimationActive={false}
      />
      <RadialBar
        label={{fill: '#666', position: 'center', strokeWidth: 0, dataKey: 'label' }}
        background={{fill: '#666'}}
        clockWise={true}
        dataKey='value'
        isAnimationActive={false}
      >
        <Cell key='cell-0' stroke='#666' strokeWidth={2} className="text-xs"/>
      </RadialBar>
    </RadialBarChart>
  )
})

function ChannelInfo({channel}) {
  return (
    <ul className="list-unstyled mb-1">
      <li>Name: {channel.name.toUpperCase()}</li>
      <li>ID: {channel.sensor_id}</li>
      <li>Serial nr: {channel.serial_nr}</li>
      <li>Certificate: {channel.certificate}</li>
    </ul>
  )
}

export default function SensorGrid({component, channels, user, tag}) {
  const items = channels
  const grid = new Map()
  var clusters = new Set()
  var positions = new Set()
  const isSuperuser = user.is_superuser
  const [rssi, setRssi] = useState(false)

  items.forEach((sensor) => {
    clusters.add(String(sensor.cluster))
    positions.add(String(sensor.position))
    if (!(String(sensor.position) in grid)) grid[String(sensor.position)] = new Map()
    grid[String(sensor.position)][String(sensor.cluster)] = sensor
  })

  clusters = Array.from(clusters).sort((c1, c2) => {
    if(c1 === 'LOCATION') return 1
    if(c2 === 'LOCATION') return -1
    if(c1 > c2) return 1
    if(c1 < c2) return -1
    return 0
  })

  positions = Array.from(positions).sort((p1, p2) => {
    if(p1.charAt(0) === 'L') return 1
    if(p2.charAt(0) === 'L') return -1
    if(p1 > p2) return 1
    if (p1 < p2) return -1
    return 0
  })

  return (
    <>
      <div className="card-header">
        <div className="row align-items-center">
          <div className="col">
            <h6 className="text-uppercase text-muted ls-1 mb-1">
              {component.name.split('_').join(' ')}
            </h6>
            <h2 className="mb-0">
              Sensor grid
            </h2>
          </div>
          <div className="col">
            {tag && <Barcode value={tag} options={{ format: 'code39', fontSize: 10, margin: 0, width: 1, height: 40 }}/>}
          </div>
          <div className='col-auto'>
            <button
              className={"btn btn-primary mb-2 w-100 text-center " + (rssi ? "active" : "")}
              onClick={() => setRssi(!rssi)}
            >
              {rssi ? `Sensor` : `RSSI`}
            </button>
          </div>
        </div>
      </div>
      <div className="flex-grow-1" style={{backgroundColor: "#f8f9fe"}}>
        <div className="table section-primary" style={gridStyle}>
        <table className='table align-items-center'>
          <thead>
            <tr>
              <th className='text-center p-2' style={smallColumn} scope='col'></th>
              {clusters.map((cluster) => (
                <th key={cluster} className='text-center p-2' style={sideTextStyle} scope='col'>{cluster}</th>
              ))}
            </tr>
          </thead>
          <tbody>
          {positions.map((position) => (
            <tr key={position}>
              <td style={tableSideStyle}>
                <span style={sideTextStyle}>
                  {position}
                </span>
              </td>
              {clusters.map((cluster) => {
                var sensors = grid[position]
                if (cluster in sensors) {
                  var channel = sensors[cluster]
                  return (
                    <td key={position + cluster} className="py-0 px-2" align="center">
                      <div>
                        {isSuperuser ? <Tooltip title={<ChannelInfo channel={channel}/>} arrow>
                          <Button className="p-0">
                            {rssi ? 
                              <ChannelGauge value={channel.rssi || 0} min={30} max={40} size={60} rssi={true}/> :
                              <ChannelGauge value={channel.value} min={component.min_value} max={component.max_value} size={60}/>}
                          </Button>
                        </Tooltip> : <>
                            {rssi ? 
                              <ChannelGauge value={channel.rssi || 0} min={30} max={40} size={60} rssi={true}/> :
                              <ChannelGauge value={channel.value} min={component.min_value} max={component.max_value} size={60}/>}</>}
                      </div>
                    </td>
                  );
                }
                return <td key={position + cluster}></td>
              })}
            </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </>
  )
}